export default __webpack_public_path__ + "static/media/first.dbedfe66.png";